import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useOverviewStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: {
        height: `100%`
      },
      gridHeaderBar: {
        marginTop: `30px`
      }
    }),
    []
  );
}
